var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.projectItems,"item-text":"name","item-value":"id","placeholder":_vm.$tc('goalsetSelect.periodeplanPlaceholder'),"clearable":"","hide-details":"","single-line":""},on:{"input":function($event){return _vm.onInput($event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }